import { FunctionComponent, ReactNode, useContext, useEffect } from "react"
import { useNavigate } from "react-router"
import { Group } from "../data/models.interface"
import { AppContext } from "./AppContext"

interface IPrivateComponent {
	groups: Group[]
	redirect?: string
	children: ReactNode
}
/**
 * Hides the component if the user does not have at least one of the groups
 */
const PrivateComponent: FunctionComponent<IPrivateComponent> = ({ groups, redirect, children }) => {
	const { groups: userGroups } = useContext(AppContext)
	const hasGroup = userGroups?.some((group) => groups.includes(group))
	const navigate = useNavigate()
	// redirect unauthorized users
	useEffect(() => {
		if (redirect && !hasGroup) {
			navigate(redirect)
		}
	})
	if (!hasGroup) return null
	return <>{children}</>
}
export default PrivateComponent
